
import loginApi from './login'
import brandApi from './brand'
import userApi from './user'
import merchantApi from './merchant'

export default {
    loginApi,
    brandApi,
    userApi,
    merchantApi,
}

// exports.install = (app) => {
//     app.config.globalProperties.$http = {
//         loginApi,
//     }
// }
